import { render } from "./BilanFormationList.vue?vue&type=template&id=77b97620"
import script from "./BilanFormationList.vue?vue&type=script&lang=js"
export * from "./BilanFormationList.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__